import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import image_404 from "../../../assets/images/404_PNG.png";

const useStyles = makeStyles(theme => ({
    leftNotFoundDiv: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.up('xl')]: {
            height: "650px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "650px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "500px",
        },
        [theme.breakpoints.down('md')]: {
            height: "350px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "250px",
        },
    },
    notFoundImage: {
        width: "auto",
        [theme.breakpoints.up('xl')]: {
            height: "650px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "650px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "500px",
        },
        [theme.breakpoints.down('md')]: {
            height: "350px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "250px",
        },
    },
    notFoundText: {
        color: "#004285",
        fontFamily: "EncodeSansBold",
        textAlign: "center",
        maxWidth: "80%",
        lineHeight: "1.3",
        [theme.breakpoints.up('xl')]: {
            fontSize: "32px",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: "32px",
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: "26px",
        },
        [theme.breakpoints.down('md')]: {
            fontSize: "22px",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: "18px",
        },

    },
    bodyDiv: {
        display: "flex",
        flexDirection: "row",
        width: "80%",
        justifyContent: "center",
        [theme.breakpoints.up('xl')]: {
            height: "448px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "400px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "336px",
        },
        [theme.breakpoints.down('md')]: {
            height: "304px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "280px",
        },
    },
}));

function InactiveBody() {
    const classes = useStyles();
    return (
        <Fragment>
            <div className={classes.bodyDiv}>
                <div className={classes.leftNotFoundDiv}>
                    <h2 className={classes.notFoundText}>Parece que su empresa no está recibiendo soporte de
                        Sancor Seguros en este momento.</h2>
                </div>
                <div>
                    <img
                        className={classes.notFoundImage}
                        src={image_404}
                    />
                </div>
            </div>
        </Fragment>
    );
}

export default InactiveBody;